import { render, staticRenderFns } from "./Turbine.vue?vue&type=template&id=7ac24104&scoped=true"
import script from "./Turbine.vue?vue&type=script&lang=js"
export * from "./Turbine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac24104",
  null
  
)

export default component.exports